export class GA4WebStrategy {
  aplicarDefaultParameters(values: GA4DefaultParametersValues, gtmId: string): void {
    if (!window.SDKAnalytics?.Web) {
      throw new Error('SDKAnalytics.Web nao disponivel no window');
    }

    const webInstance = window.SDKAnalytics.Web({ gtm: gtmId });

    const payload: GA4WebDefaultParametersPayload = {
      analytics: {
        parameters: values
      }
    };

    webInstance.setDefaultParameters(payload);
  }
}
